import { render, staticRenderFns } from "./certificates-index.vue?vue&type=template&id=6be12401&scoped=true"
import script from "./certificates-index.vue?vue&type=script&lang=js"
export * from "./certificates-index.vue?vue&type=script&lang=js"
import style0 from "./certificates-index.vue?vue&type=style&index=0&id=6be12401&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be12401",
  null
  
)

export default component.exports